import type { ReactNode } from "react";
import { SupportUploadModal } from "./SupportUpload";
export { getSupportUploadUsernameFromToken } from "./supportToken";

export const SUPPORT_UPLOAD_ENVIRONMENTS = new Set(["dev", "local"]);

export function isSupportUploadEnabled(env?: string): boolean {
  return SUPPORT_UPLOAD_ENVIRONMENTS.has(env || "");
}

export function getSupportUploadMenuItem(onClick: () => void): {
  id: string;
  label: string;
  clickHandler: () => void;
} {
  return {
    id: "support-upload",
    label: "Upload Image",
    clickHandler: onClick,
  };
}

export { SupportUploadModal };

export type SupportUploadTrigger = {
  title?: ReactNode;
  onOpen: () => void;
};